import React from 'react';
import {
 Outlet
} from 'react-router-dom';
import {
 SidebarProvider, SidebarInset, SidebarTrigger
} from 'shared/components/ui/sidebar';
import {
 Separator
} from 'shared/components/ui/separator';
import {
 DataBuilderV2Provider
} from './DataBuilderV2Context';
import DataBuilderV2Sidebar from './DataBuilderV2Sidebar';
import V2Breadcrumb from './components/V2Breadcrumb';

const DataBuilderV2Layout: React.FC = () => {
    return (
        <DataBuilderV2Provider>
            <div className="fixed inset-0 z-40 bg-background flex">
                <SidebarProvider>
                    <DataBuilderV2Sidebar />
                    <SidebarInset>
                        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
                            <SidebarTrigger className="-ml-1" />
                            <Separator orientation="vertical" className="mr-2 h-4" />
                            <V2Breadcrumb />
                        </header>
                        <div className="flex flex-1 flex-col p-4 overflow-auto">
                            <Outlet />
                        </div>
                    </SidebarInset>
                </SidebarProvider>
            </div>
        </DataBuilderV2Provider>
    );
};

export default DataBuilderV2Layout;
